<script>
import { VExpansionPanel } from 'vuetify/lib';
export default VExpansionPanel;
</script>
